import React, { Component } from "react";
import { connect } from "react-redux";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import {
  DataGrid,
  Column,
  Button,
  SearchPanel,
  FilterRow,
  HeaderFilter,
  ColumnChooser,
  Export,
  Grouping,
  GroupPanel,
  Selection,
} from "devextreme-react/data-grid";

import { ExcelJS, Workbook } from "exceljs";
import saveAs from "file-saver";
import { exportDataGrid as exportDataGridToExcel } from "devextreme/excel_exporter";

import CustomStore from "devextreme/data/custom_store";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import Switch from "@material-ui/core/Switch";

import { getDepartmentsCentersList } from "../../../apis/departments/centers/getDepartmentsCentersList.js";
import { setDepartmentCentersStatus } from "../../../apis/departments/centers/setDepartmentcenterStatus";
import { deleteDepartmentCenter } from "../../../apis/departments/centers/deleteDepartmentCenter";
import {
  triggerDialog,
  triggerDialogForm,
  setLoading,
  triggerNotification,
} from "../../../actions";
import { translationHook } from "../../translationHook";
import {
  ButtonSecondary,
  ButtonDanger,
  ButtonInfo,
  ButtonWarning,
} from "../../UI/Buttons";

import DepartmentCentersForm from "./departmentCentersForm";

class DepartmentCentersList extends Component {
  constructor(props) {
    super(props);
    this.onExporting = this.onExporting.bind(this);
  }
  customizeCellCheckbox = ({ data }) => {
    return (
      <Switch
        checked={data.Active_Status_Id}
        name={`centerStatus_${data.Department_Service_Center_Id}`}
        onChange={async () => {
          let at = this.props.currentUser.Data.access_token,
            departmentCenterId = data.Department_Service_Center_Id,
            status = data.Active_Status_Id ? 0 : 1;

          this.props.setLoading(true, "dark");

          const response = await setDepartmentCentersStatus(
            at,
            departmentCenterId,
            status
          );
          this.props.triggerNotification(true, response);

          this.props.setLoading(false);
        }}
      />
    );
  };

  renderCenterForm = (...params) => {
    let viewMood = params[2] === "view" ? true : false,
      editMood = params[2] === "edit" ? true : false;

    return (
      <DepartmentCentersForm
        departmentCenterId={params[0]}
        initValues={params[1]}
        editMood={editMood}
        viewMood={viewMood}
      />
    );
  };

  handleDelete = (data) => {
    let at = this.props.currentUser.Data.access_token,
      departmentCentersId = data.Department_Service_Center_Id,
      departmentSectionName =
        this.props.i18n.language === "ar"
          ? data.Department_Service_Center_Name_AR
          : data.Department_Service_Center_Name_EN,
      dialogTitle = `${this.props.t(
        "confirmDeleteTitle"
      )} ${departmentSectionName}`,
      dialogMsg = this.props.t("confirmDeleteMsg");

    this.props.triggerDialog(true, {
      title: dialogTitle,
      message: dialogMsg,
      action: {
        action: deleteDepartmentCenter,
        params: [at, departmentCentersId],
        text: this.props.t("delete"),
      },
    });
  };

  handleEdit = (data, viewMood) => {
    let initValues = {
        centerNo: data.Department_Service_Center_Id,
        centerStatus: data.Active_Status_Id,
        centerNameAR: data.Department_Service_Center_Name_AR,
        centerNameEN: data.Department_Service_Center_Name_EN,
        centerAddAR: data.Department_Service_Center_Address_AR,
        centerAddEN: data.Department_Service_Center_Address_EN,
        telephone: data.Department_Service_Center_Telephone,
        email: data.Department_Service_Center_Email,
        lat: data.Department_Service_Center_latitudes,
        lng: data.Department_Service_Center_longitudes,
      },
      centerId = data.Department_Service_Center_Id,
      sectionName =
        this.props.i18n.language === "ar"
          ? data.Department_Service_Center_Name_AR
          : data.Department_Service_Center_Name_EN,
      dialogTitle = `${
        viewMood === "view" ? this.props.t("view") : this.props.t("edit")
      } ${sectionName}`;

    this.props.triggerDialogForm(true, {
      title: dialogTitle,
      renderForm: this.renderCenterForm,
      params: [centerId, initValues, viewMood],
    });
  };

  render() {
    let columnAlign = "left",
      DepcenterNameKey = "Department_Service_Center_Name_EN",
      departmentName = "Department_Name_EN",
      at = this.props.currentUser.Data.access_token;

    if (this.props.i18n.language === "ar") {
      columnAlign = "right";
      DepcenterNameKey = "Department_Service_Center_Name_AR";
      departmentName = "Department_Name_AR";
    }

    const jsonDataSource = new CustomStore({
      key: "Department_Service_Center_Id",
      load: () => {
        return getDepartmentsCentersList(
          at,
          this.props.currentUser.Data.Department_Id
        );
      },
    });

    return (
      <>
        <DepartmentCentersForm />

        <DataGrid
          className={[
            this.props.i18n.language === "ar" ? "dx-grid-ar" : "dx-grid-en",
            "globalBox",
          ].join(" ")}
          id="dataGrid"
          width={"100%"}
          dataSource={jsonDataSource}
          showBorders={false}
          showColumnLines={false}
          showRowLines={true}
          allowColumnResizing={true}
          columnResizingMode={"widget"}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          focusedRowEnabled={true}
          onExporting={this.onExporting}
          columnWidth={"auto"}
          wordWrapEnabled={true}
          rtlEnabled={this.props.i18n.language === "ar" ? true : false}
        >
          <ColumnChooser
            enabled={true}
            allowSearch={true}
            search={"fff"}
            title={this.props.t("dxColumnChooserTitle")}
            emptyPanelText={this.props.t("dxColumnChooserPanelText")}
          />

          <SearchPanel
            visible={true}
            width={240}
            placeholder={this.props.t("search")}
          />

          <FilterRow visible={true} />

          <HeaderFilter visible={true} />

          <Export enabled={true} allowExportSelectedData={true} />

          <Grouping contextMenuEnabled={true} expandMode="rowClick" />
          <GroupPanel
            visible={true}
            emptyPanelText={this.props.t("dxGroupPanelText")}
          />

          <Selection
            mode="multiple"
            selectAllMode={"allPages"}
            showCheckBoxesMode={"always"}
          />

          <Column
            dataField="Department_Service_Center_Id"
            caption={this.props.t("centerNo")}
            alignment={"center"}
          ></Column>

          <Column
            dataField={DepcenterNameKey}
            caption={this.props.t("centerName")}
            alignment={columnAlign}
          ></Column>
          <Column
            cssClass="outlinedColumn"
            dataField={departmentName}
            caption={this.props.t("departmentName")}
            alignment={"center"}
          ></Column>

          <Column
            dataField="Active_Status_Id"
            caption={this.props.t("centerStatus")}
            allowFiltering={false}
            cellRender={this.customizeCellCheckbox}
          ></Column>

          <Column
            cssClass="outlinedColumn nowrapColumn"
            type="buttons"
            caption={this.props.t("details")}
            fixed={true}
            fixedPosition={this.props.i18n.language === "ar" ? "left" : "right"}
          >
            <Button
              render={(record) => {
                return (
                  <ButtonWarning
                    variant="circleIcon"
                    startIcon={<EditIcon />}
                    onClick={() => {
                      this.handleEdit(record.data, "edit");
                    }}
                  >
                    {/* {this.props.t('edit')} */}
                  </ButtonWarning>
                );
              }}
            />

            <Button
              render={(record) => {
                return (
                  <ButtonInfo
                    variant="circleIcon"
                    startIcon={<VisibilityIcon />}
                    onClick={() => {
                      this.handleEdit(record.data, "view");
                    }}
                  >
                    {/* {this.props.t('view')} */}
                  </ButtonInfo>
                );
              }}
            />

            <Button
              render={(record) => {
                return (
                  <ButtonDanger
                    variant="circleIcon"
                    startIcon={<DeleteIcon />}
                    onClick={() => this.handleDelete(record.data)}
                  >
                    {/* {this.props.t('delete')} */}
                  </ButtonDanger>
                );
              }}
            />
          </Column>
        </DataGrid>
      </>
    );
  }

  onExporting(e) {
    let sheetTitle = this.props.t("manageCenters");
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGridToExcel({
      component: e.component,
      worksheet: worksheet,
      autoFilterEnabled: true,
      topLeftCell: { row: 2, column: 2 },
      topRightCell: { row: 2, column: 2 },
      customizeCell: ({ gridCell, excelCell }) => {
        // excelCell.value = gridCell.value;
        excelCell.font = {
          family: 2,
          name: "Cairo",
          size: 10,
          color: { argb: "151713" },
        };
        excelCell.alignment = { indent: 1, wrapText: true, vertical: "middle" };
        if (gridCell.rowType === "group") {
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "d0b166" },
          };
          excelCell.alignment = { indent: 2 };
          excelCell.font = {
            family: 2,
            name: "Cairo",
            size: 10,
            color: { argb: "ffffff" },
            bold: true,
          };
        }
        if (gridCell.rowType === "header") {
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "58743a" },
          };
          excelCell.alignment = { vertical: "middle", horizontal: "center" };
          excelCell.font = {
            family: 2,
            name: "Cairo",
            size: 12,
            color: { argb: "ffffff" },
            bold: true,
          };
        }
      },
    }).then(function () {
      workbook.xlsx.writeBuffer().then(function (buffer) {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          `${sheetTitle}.xlsx`
        );
      });
    });
    e.cancel = true;
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser,
    reload: state.reload,
  };
};

export default connect(mapStateToProps, {
  triggerDialog,
  triggerDialogForm,
  triggerNotification,
  setLoading,
})(translationHook(DepartmentCentersList));
